/*
 * Copyright (c) 2020. American Express Company
 */

export enum MonteCarloEstimate {
    PESSIMISTIC = '10',
    AVERAGE = '50',
    OPTIMISTIC = '90'
}
